// extracted by mini-css-extract-plugin
export var cardLayout = "_6m-1";
export var paginationContainer = "_6m-0";